import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import { postRequest, multipartRequest, getRequest } from '@/utils/request';
import * as http from '@/utils/request-silence';
import { getToken } from '@/utils/storage';
var api = process.env['VUE_APP_AI_API'];
var sseApi = process.env['VUE_APP_AI_SSE_API'];
var tokenKey = 'ai-token';
var defaultConfig = {
  baseUrl: api,
  tokenKey: tokenKey
};
/**
 * 获取用户信息
 * @param data
 * @param config = {}
 * @return { AxiosPromise }
 */
export var getUserToken = function getUserToken(data) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return getRequest('/user/get/token', data, Object.assign({}, defaultConfig, config));
};

/**
 * 初始化window
 * @return {AxiosPromise}
 */
export var initChatWindow = function initChatWindow() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return postRequest('/ai/chat-window-init', {}, Object.assign({}, defaultConfig, config));
};

/**
 * 发送回答
 * @param data
 * @param customToken 可选的token参数，如果不传则使用默认token
 * @return {AxiosPromise}
 */
export var sendMessage = function sendMessage(data, customToken) {
  return fetch("".concat(sseApi, "/ai/chat-messages"), {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: customToken || getToken(tokenKey)
    },
    body: JSON.stringify(data)
  });
};

/**
 * 停止回答
 * @param taskId
 * @param user
 @param customToken 可选的token参数，如果不传则使用默认token
 * @return {AxiosPromise}
 */
export var stopThinking = function stopThinking(taskId, customToken) {
  return fetch("".concat(sseApi, "/ai/chat-messages/stop"), {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: customToken || getToken(tokenKey)
    },
    body: JSON.stringify({
      taskId: taskId
    })
  });
};

/**
 * 登录
 * @param data
 * @return {AxiosPromise}
 */
export var login = function login(data) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return postRequest('/ai-user/save-update', data, Object.assign({}, defaultConfig, config));
};

/**
 * 博查联网查询参考文章
 * @param data
 * @param config
 * @return {AxiosPromise}
 */
export var webQuery = function webQuery() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    count: 10,
    page: 1,
    query: ''
  };
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return http.postRequest('/ai/web/search/bocha', data, Object.assign({}, defaultConfig, config));
};

/**
 * 法规库查询
 * @param data
 * @param config
 * @return {AxiosPromise}
 */
export var lawQuery = function lawQuery() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    query: ''
  };
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return http.postRequest('/es/web/library-api', data, Object.assign({}, defaultConfig, config));
};

/**
 * 回答结束，获取推荐文章
 * @param data
 * @param config
 * @return {AxiosPromise}
 */
export var getReferDoc = function getReferDoc(data) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return postRequest('/conf-card/query-card', data, Object.assign({}, defaultConfig, config));
};

/**
 * 回答结束，获取推荐文章(新）
 * @param data
 * @param config
 * @return {AxiosPromise}
 */
export var getRecommendDoc = function getRecommendDoc(data) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return postRequest('/conf-policy/get-policy-list', data, Object.assign({}, defaultConfig, config));
};

/**
 *
 * @param data
 * @param config
 * @return {AxiosPromise}
 */
export var answerEvaluate = function answerEvaluate(data) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return postRequest('/ai-answer-log/ai-answer-evaluate', data, Object.assign({}, defaultConfig, config));
};

/**
 * 会话列表
 * @param data
 * @param config
 * @return {AxiosPromise}
 */
export var conversationHistory = function conversationHistory(data) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return postRequest('/ai-q-log/history-page', data, Object.assign({}, defaultConfig, config));
};

/**
 * 获取一个会话的聊天记录
 */
export var getOneConversationRecord = function getOneConversationRecord(data) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return postRequest('/ai-q-log/q-a-log-page', data, Object.assign({}, defaultConfig, config));
};

/**
 * 获取评论(点踩）标签
 */
export var getEvaluateTags = function getEvaluateTags(data) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return postRequest('/conf-label/get-conf-label', data, Object.assign({}, defaultConfig, config));
};

/**
 * 语音转文字
 * @param data
 * @param config
 * @returns {AxiosPromise}
 */
export var convertVideoToText = function convertVideoToText(data) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return multipartRequest('/video-to-text/gummy/sync', data, Object.assign({}, defaultConfig, config));
};

/**
 * 修改AI答案
 * @param data
 * @param config
 * @returns {AxiosPromise}
 */
export var updateAnswer = function updateAnswer(data) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return http.postRequest('/ai-answer-log/update-answer', data, Object.assign({}, defaultConfig, config));
};

/**
 * 获取分享记录
 * @param data
 * @param config
 * @returns {AxiosPromise}
 */
export var getRecordByQLogId = function getRecordByQLogId() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    qlogIds: []
  };
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return http.postRequest('/ai-q-log/share-logs', data, Object.assign({}, defaultConfig, config));
};